import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import apiClient from "../utils/apiClient";
import { SERVER_BASE } from "../config/server";
import moment from "moment";
import Swal from "sweetalert2";

const CanteenSaleList = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);

  const fetchList = async () => {
    const res = await apiClient.get(`${SERVER_BASE}/canteen-sale`);
    setData(res.data);
  };

  useEffect(() => {
    fetchList();
  }, []);

  const handleDelete = async (id) => {
  const result = await Swal.fire({
    title: "Delete Sale?",
    text: "This action cannot be undone",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes, delete",
    cancelButtonText: "Cancel",
  });

  if (!result.isConfirmed) return;

  try {
    await apiClient.delete(`${SERVER_BASE}/canteen-sale/${id}`);

    Swal.fire("Deleted", "Canteen sale deleted", "success");

    // refresh list
    fetchList();
  } catch (err) {
    Swal.fire("Error", "Failed to delete sale", "error");
  }
};
const viewItems = (items) => {
  const html = `
    <table class="table table-bordered table-sm align-middle">
      <thead class="table-light">
        <tr>
          <th style="width:60px">S.No</th>
          <th>Item</th>
          <th style="width:120px">Qty</th>
          <th style="width:100px">UOM</th>
        </tr>
      </thead>
      <tbody>
        ${
          items?.length
            ? items
                .map(
                  (i, index) => `
                  <tr>
                    <td class="text-center">${index + 1}</td>
                    <td>${i.printName}</td>
                    <td class="text-end fw-semibold">${i.quantity}</td>
                    <td class="text-center">${i.uom}</td>
                  </tr>
                `
                )
                .join("")
            : `
              <tr>
                <td colspan="4" class="text-center text-muted">
                  No items found
                </td>
              </tr>
            `
        }
      </tbody>
    </table>
  `;

  Swal.fire({
    title: "Canteen Sale Items",
    html,
    width: "720px",
    confirmButtonText: "Close",
    confirmButtonColor: "#6c63ff",
  });
};


  return (
    <div className="formcontainer mt-5">
      <h4>Canteen Sales</h4>

      <button
        className="btn btn-primary mb-3"
        onClick={() => navigate("../canteenSale")}
      >
        New Sale
      </button>

      <table className="table table-bordered">
        <thead>
          <tr>
            <th>ID</th>
            <th>Date</th>
            <th>Time</th>
            <th>Project</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {data.map((d,index) => (
            <tr key={d.id}>
              <td>{index+1}</td>
              <td>{d.saleDate?moment(d.saleDate).format('DD MMM YYYY'):""}</td>
              <td>{d.saleTime}</td>
              <td>{d.projectName}</td>
             <td>
  <button
    className="btn btn-sm btn-info me-2"
    onClick={() => viewItems(d.items)}
  >
    View
  </button>

  <button
    className="btn btn-sm btn-warning me-2"
    onClick={() =>
      navigate("../canteenSale", { state: { id: d.id } })
    }
  >
    Edit
  </button>

  <button
    className="btn btn-sm btn-danger"
    onClick={() => handleDelete(d.id)}
  >
    Delete
  </button>
</td>


            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CanteenSaleList;
